import React from 'react';
import { Modal } from 'react-bootstrap'
import PropTypes from 'prop-types';
import {
  FormGroup,
  InputGroup,
  Button,
  ButtonToolbar,
  ControlLabel,
  FormControl,
  HelpBlock,
  Table,
  ButtonGroup,
} from 'react-bootstrap';
import { Form, Field } from 'react-final-form';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';


const sortProperties = [];

export const renderTextField = ({ input, label, type, meta: { touched, error, warning } }) => (
  <InputGroup>
    {label && (<ControlLabel>{label}</ControlLabel>)}
    <FormControl
      {...input}
      type={type}
    />
  </InputGroup>
);

class LandmarksForm extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
    //this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDel = this.handleDel.bind(this);
    this.getRow = this.getRow.bind(this)
    this.cancelRow = this.cancelRow.bind(this)
    this.onClose = this.onClose.bind(this)

    this.state = {
      show: false,
      id: 0,
      name: "",
      distance: "",
      showValidationError: false,
      errorMsg:''
    };
  }
  onSubmit = (values) => {
    console.log('on submit called')
    if (values.distance == "" || values.name == "") {
      this.setState({ showValidationError: true, errorMsg: 'Please enter Name and Distance' })
      return false;
    }
    if(!(/^\s*[+-]?(\d+|\.\d+|\d+\.\d+|\d+\.)(e[+-]?\d+)?\s*$/.test(values.distance))){
      this.setState({showValidationError: true,  errorMsg: 'Distance should be Number'})
      return false;
    }
    if (values.id == 0) {
      this.props.postHotelAddLandmark(this.props.isAddHotel ? this.props.hotel.hotels[0].id : this.props.hotel.id, values)
    }
    else {
      this.props.editLandmark(values.id, values)
    }
    this.setState({ show: false });
  }


  handleSubmit(values) {
    //debugger;
    const initialValues = this.props.tour;
    const isNew = this.props.tour.id ? false : true;
    if (isNew) {
      return this.handleAddTour(values, initialValues);
    }
    return this.handleEditTour(values, initialValues);
  }

  handleClose() {
    this.setState({ show: false });
  }
  onClose() {
    this.setState({ showValidationError: false });
  }
  handleShow() {
    this.setState({ show: true, name: "", distance: "", id: 0 });
  }
  handleDel() {
    this.setState({ show: true });
  }

  getRow(cell, row) {
    this.setState({ show: true, id: row.id, name: row.name, distance: row.distance.substr(0, (row.distance.indexOf("M") - 1)) }, () =>
      console.log(this.state.name));
  }

  cancelRow(cell, row) {
    this.props.removeLandmark(row.id)
  }

  render() {
    const errors = {};
    const pristine = "";
    let landmark_data = "";
    let landmark_arr = [];
    // if (this.props.isAddHotel && this.props.hotel.hotels.length) {
    //   landmark_data = this.props.hotel.hotels[0].landmarks;
    //   if (landmark_data !== undefined && landmark_data.length) {
    //     landmark_data.map(c => {
    //       landmark_arr.push({ "id": c.id, "name": c.name, "distance": c.distance + " Miles" })
    //     })
    //   }
    // } else {
      landmark_data = this.props.hotel.landmarks;
      if (landmark_data !== undefined && landmark_data.length) {
        this.props.hotel.landmarks.map(c => {
          landmark_arr.push({ "id": c.id, "name": c.name, "distance": c.distance + " Miles" })
        })
      }
    //}
    const cellEditProp = {
      mode: 'dbclick',
      blurToSave: true,
    };

    const buttonFormatter = (cell, row) => <div>
      <Button onClick={() => this.getRow(cell, row)} ><i className="fa fa-pencil fa-lg" style={{ bordercolor: '#5bc0e8 !important' }} /></Button>&nbsp;&nbsp;&nbsp;&nbsp; 
      <Button onClick={() => this.cancelRow(cell, row)} ><i className="fa fa-remove" style={{ bordercolor: '#5bc0e8' }} /></Button>
    </div>;
  const ButtonColumn = ({ value }) => (
      <ButtonGroup>
        <Button bsStyle="info" data-item={value} onClick={this.handleShow}>
          <i className="fa fa-pencil fa-lg" />
        </Button>
        <Button bsStyle="info" data-item={value} onClick={this.handleDel}>
          <i className="fa fa-trash fa-md" />
        </Button>
      </ButtonGroup>
    );
    if(!this.props.isHotelView){
    return (
      <div className="row">
        <div className="col-md-11">
          <h1 className="hotel-detail-subheada">
            Nearest Airport/Train Station
                </h1>
        </div>
        <div className="col-md-1">
          {
            !this.props.isHotelView ? <Button bsStyle="success" onClick={this.handleShow}> Add </Button> : ''
            
          }
        </div>

        <Modal show={this.state.show} onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Add Landmark</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form
              onSubmit={this.onSubmit}
              initialValues={{ name: this.state.name, distance: this.state.distance, id: this.state.id }}
              render={({ handleSubmit, pristine, invalid }) => (
                <form onSubmit={handleSubmit} >
                  <div className="col-md-8"><h4 className="hotel-highlight"></h4></div>
                  <FormGroup>
                    <Field
                      name="id"
                      type="hidden"
                      component={renderTextField}
                      label=""
                      placeholder=""
                    />
                    <Field
                      name="name"
                      type="text"
                      component={renderTextField}
                      label="Landmark"
                      placeholder=""
                    />
                    <Field
                      name="distance"
                      component={renderTextField}
                      label="Distance(In Miles)"
                      placeholder=""
                    />
                  </FormGroup>
                  {errors !== undefined && errors.FORM_ERROR && (
                    <p className="alert alert-danger">{errors.FORM_ERROR}</p>
                  )}
                  {errors !== undefined && errors.note && (
                    <p className="alert alert-danger">{errors.note}</p>
                  )}
                  <FormGroup>
                    <ButtonToolbar>
                      <Button
                        disabled={false}
                        bsStyle="success"
                        type="submit"
                      >
                        Save
                            </Button>
                      <Button
                        disabled={false}
                        bsStyle="success"
                        onClick={this.handleClose}
                      >
                        Cancel
                            </Button>
                    </ButtonToolbar>
                  </FormGroup>
                </form>
              )}
            />
          </Modal.Body>
          <Modal.Footer>
          </Modal.Footer>
        </Modal>
        {this.state.showValidationError && (<Modal show={this.state.showValidationError} onHide={this.onClose}>
          <Modal.Header closeButton>
            <Modal.Title>Incorrect data</Modal.Title>
          </Modal.Header>
          <Modal.Body>

            <p> {this.state.errorMsg}</p>

            <ButtonToolbar style={{ float: 'right' }}>
              <Button
                bsStyle="success"
                onClick={this.onClose}
              >
                Ok
                          </Button>
            </ButtonToolbar>
          </Modal.Body>
          <Modal.Footer style={{ clear: 'both' }} />
        </Modal>
        )}
        <div className="row">

          <BootstrapTable
            data={landmark_arr}
            bordered={false}
            cellEdit={cellEditProp}
          >
            <TableHeaderColumn dataField="name" width="90" headerAlign="center" dataAlign="center" editable={false} >Landmark</TableHeaderColumn>
            <TableHeaderColumn dataField="distance" width="90" headerAlign="center" dataAlign="center" editable={false}>Distance</TableHeaderColumn>
            <TableHeaderColumn dataField="id" width="100" isKey headerAlign="center" dataAlign="center" dataFormat={buttonFormatter} editable={false}>Action</TableHeaderColumn>
          </BootstrapTable>

        </div>

      </div>

    )
          }else{
            return (
              <div className="row">
                <div className="col-md-11">
                  <h1 className="hotel-detail-subheada">
                    Surroundings and Landmarks
                        </h1>
                </div>
                <div className="col-md-1">
                  {
                  }
                </div>
                <div className="row" style={{marginLeft:"2px",marginRight:"2px"}}>
                  <BootstrapTable
                    data={landmark_arr}
                    bordered={false}
                    cellEdit={cellEditProp}
                  >
                    <TableHeaderColumn dataField="name" isKey width="90" headerAlign="center" dataAlign="center" editable={false} >Landmark</TableHeaderColumn>
                    <TableHeaderColumn dataField="distance" width="90" headerAlign="center" dataAlign="center" editable={false}>Distance</TableHeaderColumn>
                  </BootstrapTable>
                </div>
              </div>
            )  
          };
    }
}



export default LandmarksForm;
  //render(<Example />);


// WEBPACK FOOTER //
// src/routes/hotels/components/LandmarksForm.js